import { useParams, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useFactoryStore } from "@/core/hooks/useFactory";
import { useAppScope } from "@/core/AppScopeContext";
import { ChecklistBuilder } from "@/modules/checklist/components/ChecklistBuilder";

export default function InstructionDetailPage() {
  const { instructionId } = useParams<{ instructionId: string }>();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { selectedFactoryId } = useFactoryStore();
  const { selectedTenantId } = useAppScope();

  if (!selectedFactoryId || !selectedTenantId || !instructionId) {
    return (
      <div className="bg-card rounded-xl shadow-card border border-border p-12 text-center">
        <h2 className="text-xl font-semibold text-foreground mb-2">
          {!selectedFactoryId
            ? "No Factory Selected"
            : !selectedTenantId
              ? "No Tenant Selected"
              : "Invalid Work Instruction"}
        </h2>
        <p className="text-muted-foreground">
          {!selectedFactoryId
            ? "Please select a factory to access Work Instructions."
            : !selectedTenantId
              ? "Please select a tenant to access Work Instructions."
            : "The requested work instruction could not be found."}
        </p>
      </div>
    );
  }

  const handleBack = () => {
    queryClient.invalidateQueries({
      queryKey: ["work-instructions", selectedTenantId, selectedFactoryId],
    });
    navigate("/instructions");
  };

  return (
    <div className="space-y-4 md:space-y-6 animate-fade-in">
      <ChecklistBuilder
        factoryId={selectedFactoryId}
        tenantId={selectedTenantId}
        onBack={handleBack}
        instructionId={instructionId}
      />
    </div>
  );
}
